import React, { useState } from 'react';
import '../../App.css';
import '../../scss/App.scss';
import '../../scss/Hotel.scss';
import { Box, Container, Grid, Link } from '@mui/material';

function HotelList() {
    const [value, setValue] = useState('');
    const hotelCards = [
        { id: 1, title: "Apart hotel", image: "../assets/hotel/cards/discover1.svg" },
        { id: 2, title: "Apart hotel", image: "../assets/hotel/cards/discover2.svg" },
        { id: 3, title: "Apart hotel", image: "../assets/hotel/cards/discover3.svg" },
        { id: 4, title: "Apart hotel", image: "../assets/hotel/cards/discover4.svg" },
    ];

    const min = 0;
    const max = 22200;
    const step = 10;

    const [minValue, setMinValue] = useState(500);
    const [maxValue, setMaxValue] = useState(22200);

    const handleMinChange = (e) => {
        const value = Math.min(Number(e.target.value), maxValue - step);
        setMinValue(value);
    };

    const handleMaxChange = (e) => {
        const value = Math.max(Number(e.target.value), minValue + step);
        setMaxValue(value);
    };

const hotelData = [
  {
    name: "Hotel Janki International",
    location: "Varanasi",
    price: 1400,
    image: "../assets/hotel/hotel-card/hotel-card-square.svg",
    reviewIcon: "../assets/hotel/review.svg",
    amenitiesIcon: "../assets/hotel/cafe.svg",
    ratingLabel: "5 Star Hotel",
    amenities: "20+ Amenities",
    reviewScore: "4.3",
    reviewText: "Very Good",
    reviewCount: 54
  },
  {
    name: "Hotel Janki International",
    location: "Varanasi",
    price: 1400,
    image: "../assets/hotel/hotel-card/hotel-card-square.svg",
    reviewIcon: "../assets/hotel/review.svg",
    amenitiesIcon: "../assets/hotel/cafe.svg",
    ratingLabel: "5 Star Hotel",
    amenities: "20+ Amenities",
    reviewScore: "4.3",
    reviewText: "Very Good",
    reviewCount: 54
  },
  
  {
    name: "Hotel Janki International",
    location: "Varanasi",
    price: 1400,
    image: "../assets/hotel/hotel-card/hotel-card-square.svg",
    reviewIcon: "../assets/hotel/review.svg",
    amenitiesIcon: "../assets/hotel/cafe.svg",
    ratingLabel: "5 Star Hotel",
    amenities: "20+ Amenities",
    reviewScore: "4.3",
    reviewText: "Very Good",
    reviewCount: 54
  },
  
  {
    name: "Hotel Janki International",
    location: "Varanasi",
    price: 1400,
    image: "../assets/hotel/hotel-card/hotel-card-square.svg",
    reviewIcon: "../assets/hotel/review.svg",
    amenitiesIcon: "../assets/hotel/cafe.svg",
    ratingLabel: "5 Star Hotel",
    amenities: "20+ Amenities",
    reviewScore: "4.3",
    reviewText: "Very Good",
    reviewCount: 54
  },
  

  {
    name: "Hotel Janki International",
    location: "Varanasi",
    price: 1400,
    image: "../assets/hotel/hotel-card/hotel-card-square.svg",
    reviewIcon: "../assets/hotel/review.svg",
    amenitiesIcon: "../assets/hotel/cafe.svg",
    ratingLabel: "5 Star Hotel",
    amenities: "20+ Amenities",
    reviewScore: "4.3",
    reviewText: "Very Good",
    reviewCount: 54
  },
  

  {
    name: "Hotel Janki International",
    location: "Varanasi",
    price: 1400,
    image: "../assets/hotel/hotel-card/hotel-card-square.svg",
    reviewIcon: "../assets/hotel/review.svg",
    amenitiesIcon: "../assets/hotel/cafe.svg",
    ratingLabel: "5 Star Hotel",
    amenities: "20+ Amenities",
    reviewScore: "4.3",
    reviewText: "Very Good",
    reviewCount: 54
  },
  
];
    return (
        <>
            <section className="hotelBanner p-0">

                <div id="carouselExampleControls" className="carousel slide" data-bs-ride="carousel">
                    <div className="carousel-inner">
                        <div className="carousel-item active">
                            <img src="../assets/hotel/banner/hotel-banner.webp" className="d-block w-100" alt="..." />
                        </div>
                        <div className="carousel-item">
                            <img src="../assets/hotel/banner/hotel-banner.webp" className="d-block w-100" alt="..." />
                        </div>
                        <div className="carousel-item">
                            <img src="../assets/hotel/banner/hotel-banner.webp" className="d-block w-100" alt="..." />
                        </div>
                    </div>
                    <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
                        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span className="visually-hidden">Previous</span>
                    </button>
                    <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
                        <span className="carousel-control-next-icon" aria-hidden="true"></span>
                        <span className="visually-hidden">Next</span>
                    </button>
                </div>

                <div className="bannerFormOverlay formLabel">
                    <div className={`floating-placeholder-group ${value ? 'active' : ''}`}>
                        <img
                            src="../assets/hotel/form-icon/bed.svg"
                            className="input-icon"
                            alt="icon"
                        />
                        <input
                            type="text"
                            className="form-control"
                            value={value}
                            onChange={(e) => setValue(e.target.value)}
                        />
                        <span className="floating-placeholder">Enter destination</span>
                    </div>
                    <div className={`floating-placeholder-group ${value ? 'active' : ''}`}>
                        <img
                            src="../assets/hotel/form-icon/calender.svg"
                            className="input-icon"
                            alt="icon"
                        />
                        <input
                            type="text"
                            className="form-control"
                            value={value}
                            onChange={(e) => setValue(e.target.value)}
                        />
                        <span className="floating-placeholder">Check In</span>
                    </div>

                    <div className={`floating-placeholder-group ${value ? 'active' : ''}`}>
                        <img
                            src="../assets/hotel/form-icon/calender.svg"
                            className="input-icon"
                            alt="icon"
                        />
                        <input
                            type="text"
                            className="form-control"
                            value={value}
                            onChange={(e) => setValue(e.target.value)}
                        />
                        <span className="floating-placeholder">Check Out</span>
                    </div>

                    <div className={`floating-placeholder-group ${value ? 'active' : ''}`}>
                        <img
                            src="../assets/hotel/form-icon/user.svg"
                            className="input-icon"
                            alt="icon"
                        />
                        <input
                            type="text"
                            className="form-control"
                            value={value}
                            onChange={(e) => setValue(e.target.value)}
                        />
                        <span className="floating-placeholder">Room & Guest</span>
                    </div>
                    <div className='formLabelGroup'>
                        <a href="" className='btn btn-primary'> <img
                            src="../assets/hotel/form-icon/search.svg"
                            className="searchIcon"
                            alt="icon"
                        /></a>
                    </div>
                </div>
            </section>



            <Container maxWidth="md" className="deals-header py-4">

                <Grid container spacing={6} justifyContent="center" >
                    <Grid size={{ xl: 4, lg: 4, md: 4, sm: 12, xs: 12 }}>
                        <div className='filterBox'>
                        <div className="double-range-slider">
                            <label>Price</label>

                            <div className="slider-container">
                                <div className="slider-track" />
                                <input
                                    type="range"
                                    min={min}
                                    max={max}
                                    step={step}
                                    value={minValue}
                                    onChange={handleMinChange}
                                />
                                <input
                                    type="range"
                                    min={min}
                                    max={max}
                                    step={step}
                                    value={maxValue}
                                    onChange={handleMaxChange}
                                />
                            </div>

                            <div className="range-labels">
                                <span>₹{minValue}</span>
                                <span>₹{maxValue}</span>
                            </div>
                        </div>

                        <div className="ratingBox">
                            <h5>Rating</h5>
                            <div className="rating">
                                <a href='#'>0+</a>
                                <a href='#'>1+</a>
                                <a href='#'>2+</a>
                                <a href='#'>3+</a>
                                <a href='#'>4+</a>
                            </div>
                        </div>


                        <div className="freebies-filter">
                            <h6 className="bold mb-3">Freebies</h6>

                            <div className="form-check mb-2">
                                <input className="form-check-input" type="checkbox" id="freeBreakfast" />
                                <label className="form-check-label" for="freeBreakfast">Free breakfast</label>
                            </div>

                            <div className="form-check mb-2">
                                <input className="form-check-input" type="checkbox" id="freeParking" />
                                <label className="form-check-label" for="freeParking">Free parking</label>
                            </div>

                            <div className="form-check mb-2">
                                <input className="form-check-input" type="checkbox" id="freeInternet" />
                                <label className="form-check-label" for="freeInternet">Free internet</label>
                            </div>

                            <div className="form-check mb-2">
                                <input className="form-check-input" type="checkbox" id="freeShuttle" />
                                <label className="form-check-label" for="freeShuttle">Free airport shuttle</label>
                            </div>

                            <div className="form-check mb-2">
                                <input className="form-check-input" type="checkbox" id="freeCancellation" />
                                <label className="form-check-label" for="freeCancellation">Free cancellation</label>
                            </div>
                        </div>



                        <div className="freebies-filter amenities">
                            <h6 className="bold mb-3">Amenities</h6>

                            <div className="form-check mb-2">
                                <input className="form-check-input" type="checkbox" id="freeBreakfast" />
                                <label className="form-check-label" for="freeBreakfast">24hr front desk</label>
                            </div>

                            <div className="form-check mb-2">
                                <input className="form-check-input" type="checkbox" id="freeParking" />
                                <label className="form-check-label" for="freeParking">Air-conditioned</label>
                            </div>

                            <div className="form-check mb-2">
                                <input className="form-check-input" type="checkbox" id="freeInternet" />
                                <label className="form-check-label" for="freeInternet">Fitness</label>
                            </div>

                            <div className="form-check mb-2">
                                <input className="form-check-input" type="checkbox" id="freeShuttle" />
                                <label className="form-check-label" for="freeShuttle">Pool</label>
                            </div>

                            <span>+24 more</span>
                        </div>
                        </div>
                    </Grid>
                    <Grid size={{ xl: 8, lg: 8, md: 8, sm: 12, xs: 12 }}>
                        <div className='tabBox'>
                            <ul className="nav nav-tabs custom-tabs" id="propertyTypeTab" role="tablist">
                                <li className="nav-item" role="presentation">
                                    <button className="nav-link active" id="hotels-tab" data-bs-toggle="tab" data-bs-target="#hotels" type="button" role="tab">
                                        <div className="tab-title">Hotels</div>
                                        <div className="tab-subtitle">257 places</div>
                                    </button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button className="nav-link" id="motels-tab" data-bs-toggle="tab" data-bs-target="#motels" type="button" role="tab">
                                        <div className="tab-title">Motels</div>
                                        <div className="tab-subtitle">51 places</div>
                                    </button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button className="nav-link" id="resorts-tab" data-bs-toggle="tab" data-bs-target="#resorts" type="button" role="tab">
                                        <div className="tab-title">Resorts</div>
                                        <div className="tab-subtitle">72 places</div>
                                    </button>
                                </li>
                            </ul>

                            {/* <div className="tab-content p-3">
                                <div className="tab-pane fade show active" id="hotels" role="tabpanel">Hotels content...</div>
                                <div className="tab-pane fade" id="motels" role="tabpanel">Motels content...</div>
                                <div className="tab-pane fade" id="resorts" role="tabpanel">Resorts content...</div>
                            </div> */}


                           {hotelData.map((hotel, index) => (
  <div className="carList" key={index}>
    <div className="listCardImg">
      <img
        src={hotel.image}
        className="img-fluid"
        alt={hotel.name}
      />
    </div>

    <div className="listCardDescription">
      <div className="hotelLocationBox">
        <div className="location">
          <h3 className="mb-1">{hotel.name}</h3>
          <div className="locationInfo">
            <img src="../assets/hotel/location.svg" alt="location" />
            <span>{hotel.location}</span>
          </div>
        </div>
        <div className="price">
          <p className="text-start">starting from</p>
          <span>₹{hotel.price}/night</span>
          <p className="text-end">excl. tax</p>
        </div>
      </div>

      <div className="reviewBox">
        <Grid container spacing={1} alignItems="center">
          <Grid item xl={7} lg={7} md={7} sm={12} xs={12}>
            <div className="reviewImg">
              <img src={hotel.reviewIcon} alt="review" />
              <span>{hotel.ratingLabel}</span>
            </div>
          </Grid>
          <Grid item xl={5} lg={5} md={5} sm={12} xs={12}>
            <div className="aminitiesImg">
              <img src={hotel.amenitiesIcon} alt="amenities" />
              <span>{hotel.amenities}</span>
            </div>
          </Grid>
          <Grid item xs={12}>
            <div className="totalReview">
              <p>{hotel.reviewScore}</p>
              <span>
                <strong>{hotel.reviewText}</strong> {hotel.reviewCount} reviews
              </span>
            </div>
          </Grid>
        </Grid>
        <hr />
        <div className="viewPlace">
          <div className="heart">♡</div>
          <a href="#!" className="outlineButtonGreen w-100 text-center">View Place</a>
        </div>
      </div>
    </div>
  </div>
))}


                            
                        </div>
                    </Grid>


                </Grid>
            </Container>




        </>
    );
}
export default HotelList;